// extracted by mini-css-extract-plugin
export default {"clearfix":"footer_clearfix__wBzt7","clear":"footer_clear__fKjAt","customLink":"footer_customLink__7zJD8","Link":"footer_Link__EU8KD","footerTopLink":"footer_footerTopLink__FJioR"};